import { AppLauncherConfig } from "@store-platform/types"

export const themePresets: Array<{
  name: string
  style: AppLauncherConfig["styles"]
}> = [
  {
    name: "Basic",
    style: {
      colors: {
        canvas: "#f5f6f9ff",
        box: "#ffffffff",
        primary: "#111827ff",
        secondary: "#f9fafbff",
        mainText: "#333333ff",
        primaryLinkText: "#ffffffff",
        secondaryLinkText: "#111827ff",
        boxShadow: "#333333ff",
        taglineText: "#333333ff",
      },
      typography: { fontFamily: "Roboto" },
      layout: { outerRadius: 20, linkRadius: 12 },
    },
  },
  //{
  //   "colors": {
  //     "canvas": "#F8F8F8",
  //     "container": "#FFFFFF",
  //     "primary": "#2962FF",
  //     "secondary": "#E3F2FD",
  //     "text": "#212121",
  //     "primaryForeground": "#FFFFFF",
  //     "secondaryForeground": "#212121",
  //     "containerShadow": "#EEEEEE"
  //   },
  //   "layout": {
  //     "containerRadius": "12px",
  //     "linksRadius": "8px"
  //   }
  // }
  {
    name: "Light",
    style: {
      colors: {
        primary: "#2962FFFF",
        secondary: "#E3F2FDFF",
        mainText: "#212121FF",
        canvas: "#F8F8F8FF",
        box: "#FFFFFFFF",
        primaryLinkText: "#FFFFFFFF",
        secondaryLinkText: "#212121FF",
        taglineText: "#212121FF",
        boxShadow: "#EEEEEEFF",
      },
      typography: { fontFamily: "Roboto" },
      layout: { outerRadius: 10, linkRadius: 6 },
    },
  },
  // {
  //   "colors": {
  //     "canvas": "#121212",
  //     "container": "#1E1E1E",
  //     "primary": "#BB86FC",
  //     "secondary": "#3700B3",
  //     "text": "#EBEBEB",
  //     "primaryForeground": "#121212",
  //     "secondaryForeground": "#EBEBEB",
  //     "containerShadow": "#000000"
  //   },
  //   "layout": {
  //     "containerRadius": "12px",
  //     "linksRadius": "8px"
  //   }
  // }
  {
    name: "Dark",
    style: {
      colors: {
        primary: "#BB86FCFF",
        secondary: "#3700B3FF",
        mainText: "#EBEBEBFF",
        canvas: "#121212FF",
        box: "#1E1E1EFF",
        primaryLinkText: "#121212FF",
        secondaryLinkText: "#EBEBEBFF",
        taglineText: "#EBEBEBFF",
        boxShadow: "#000000FF",
      },
      typography: { fontFamily: "Roboto" },
      layout: { outerRadius: 10, linkRadius: 6 },
    },
  },
  // {
  //   "colors": {
  //     "canvas": "#1B202E",
  //     "container": "#2A324B",
  //     "primary": "#5A79F2",
  //     "secondary": "#324569",
  //     "text": "#F0F5FA",
  //     "primaryForeground": "#FFFFFF",
  //     "secondaryForeground": "#F0F5FA",
  //     "containerShadow": "#202738"
  //   },
  //   "layout": {
  //     "containerRadius": "12px",
  //     "linksRadius": "8px"
  //   }
  // }
  {
    name: "Outer-Space",
    style: {
      colors: {
        primary: "#5A79F2FF",
        secondary: "#324569FF",
        mainText: "#F0F5FAFF",
        canvas: "#1B202EFF",
        box: "#2A324BFF",
        primaryLinkText: "#FFFFFFFF",
        secondaryLinkText: "#F0F5FAFF",
        taglineText: "#F0F5FAFF",
        boxShadow: "#202738FF",
      },
      typography: { fontFamily: "Roboto" },
      layout: { outerRadius: 10, linkRadius: 6 },
    },
  },
  // {
  //   "colors": {
  //     "canvas": "#F5E9D9",
  //     "container": "#FFF4E7",
  //     "primary": "#E96D57",
  //     "secondary": "#BC948B",
  //     "text": "#332D29",
  //     "primaryForeground": "#FFFFFF",
  //     "secondaryForeground": "#FFFFFF",
  //     "containerShadow": "#E0D6C7"
  //   },
  //   "layout": {
  //     "containerRadius": "12px",
  //     "linksRadius": "8px"
  //   }
  // }
  {
    name: "Sunset",
    style: {
      colors: {
        primary: "#E96D57FF",
        secondary: "#BC948BFF",
        mainText: "#332D29FF",
        canvas: "#F5E9D9FF",
        box: "#FFF4E7FF",
        primaryLinkText: "#FFFFFFFF",
        secondaryLinkText: "#FFFFFFFF",
        taglineText: "#332D29FF",
        boxShadow: "#BC948BFF",
      },
      typography: { fontFamily: "Roboto" },
      layout: { outerRadius: 10, linkRadius: 6 },
    },
  },
  // {
  //   "colors": {
  //     "canvas": "#F0F7F2",
  //     "container": "#FFFFFF",
  //     "primary": "#4CAF50",
  //     "secondary": "#A5D6A7",
  //     "text": "#212121",
  //     "primaryForeground": "#FFFFFF",
  //     "secondaryForeground": "#212121",
  //     "containerShadow": "#E0E0E0"
  //   },
  //   "layout": {
  //     "containerRadius": "8px",
  //     "linksRadius": "4px"
  //   }
  // }
  {
    name: "Nature",
    style: {
      colors: {
        primary: "#4CAF50FF",
        secondary: "#A5D6A7FF",
        mainText: "#212121FF",
        canvas: "#F0F7F2FF",
        box: "#FFFFFFFF",
        primaryLinkText: "#FFFFFFFF",
        secondaryLinkText: "#212121FF",
        taglineText: "#212121FF",
        boxShadow: "#E0E0E0FF",
      },
      typography: { fontFamily: "Roboto" },
      layout: { outerRadius: 10, linkRadius: 6 },
    },
  },
  // {
  //   "colors": {
  //     "canvas": "#F5F5F5",
  //     "container": "#FFFFFF",
  //     "primary": "#4267B2",
  //     "secondary": "#CCD1E3",
  //     "text": "#1D2129",
  //     "primaryForeground": "#FFFFFF",
  //     "secondaryForeground": "#1D2129",
  //     "containerShadow": "#EEEEEE"
  //   },
  //   "layout": {
  //     "containerRadius": "12px",
  //     "linksRadius": "8px"
  //   }
  // }
  {
    name: "Social",
    style: {
      colors: {
        primary: "#4267B2FF",
        secondary: "#CCD1E3FF",
        mainText: "#1D2129FF",
        canvas: "#F5F5F5FF",
        box: "#FFFFFFFF",
        primaryLinkText: "#FFFFFFFF",
        secondaryLinkText: "#1D2129FF",
        taglineText: "#1D2129FF",
        boxShadow: "#EEEEEEFF",
      },
      typography: { fontFamily: "Roboto" },
      layout: { outerRadius: 10, linkRadius: 6 },
    },
  },
  // {
  //   "colors": {
  //     "canvas": "#121212",
  //     "container": "#242424",
  //     "primary": "#F92A82",
  //     "secondary": "#4CC9F0",
  //     "text": "#FFFFFF",
  //     "primaryForeground": "#000000",
  //     "secondaryForeground": "#000000",
  //     "containerShadow": "#000000"
  //   },
  //   "layout": {
  //     "containerRadius": "4px",
  //     "linksRadius": "0px"
  //   }
  // }
  {
    name: "Retro",
    style: {
      colors: {
        primary: "#F92A82FF",
        secondary: "#4CC9F0FF",
        mainText: "#FFFFFFFF",
        canvas: "#121212FF",
        box: "#242424FF",
        primaryLinkText: "#000000FF",
        secondaryLinkText: "#000000FF",
        taglineText: "#FFFFFFFF",
        boxShadow: "#4CC9F0FF",
      },
      typography: { fontFamily: "Roboto" },
      layout: { outerRadius: 10, linkRadius: 6 },
    },
  },
]
